import React from "react";
import TextInputForSelect from "../../TextInputForSelect/TextInputForSelect";
import MeetingTimes from "../../../Data/MeetingTimes";
import Checkbox from "../../Checkbox/Checkbox";
import "./DaySelector.css";

class DaySelector extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      menuIsOpen: false,
    };
    this.input = React.createRef();
    this.options = React.createRef();
    this.handleOnClick = this.handleOnClick.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
  }

  handleOnClick(e) {
    e.stopPropagation();
    if (this.state.menuIsOpen === false) {
      this.setState(
        {
          menuIsOpen: true,
        },
        () => {
          document.addEventListener("click", this.handleOutsideClick);
        }
      );
    } else {
      this.setState(
        {
          menuIsOpen: false,
        },
        () => {
          document.addEventListener("click", this.handleOutsideClick);
        }
      );
    }
  }

  handleOutsideClick(e) {
    let target = e.target;
    if (
      this.input.current === target ||
      this.options.current === target ||
      this.options.current.contains(target)
    ) {
      return;
    } else {
      this.setState(
        {
          menuIsOpen: false,
        },
        () => {
          document.removeEventListener("click", this.handleOutsideClick);
        }
      );
    }
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleOutsideClick);
  }

  render() {
    return (
      <div className="selector day-selector">
        <TextInputForSelect
          handleInputClick={this.handleOnClick}
          readOnly={true}
          name={this.props.daySelectorName}
          value={this.props.daysValue}
          placeholder="Select days..."
          onChange={this.props.handleDayTextChange}
          ref={this.input}
        />
        <ul
          style={{ zIndex: this.props.zIndexValue }}
          ref={this.options}
          className={
            this.state.menuIsOpen
              ? "select-options select-options-show"
              : "select-options"
          }
        >
          {MeetingTimes.days.map((d, index) => (
            <li
              key={"day_selector_" + index}
              onClick={() => this.props.handleCheckboxClick(d.value)}
            >
              {this.props.days[index] ? (
                <Checkbox
                  id={`${this.props.daySelectorName}_${d.value}_${d.id}`}
                  name={this.props.daySelectorName + "_checkbox"}
                  value={d.value}
                  isChecked={this.props.days[index].isChecked}
                  onChange={(e) => this.props.handleCheckboxOnChange(e)}
                />
              ) : null}
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

export default DaySelector;
